/**
 * @file Topbar.jsx
 * @location src/components/layout/Topbar.jsx
 * @role 상단 네비게이션 바 — orchestrator
 *
 * 좌측: TopnavBar (로고 + nav 링크)
 * 우측: NotificationBell, 다크모드,
 *       템플릿 (관리자), 휴지통, 설정, UserSwitchMenu
 *
 * razor ⑭ + ① 정합으로 GlobalSearch 폐지 — task 검색은 업무「전체」검색바, member 검색은 인원(MembersPage).
 */
import { useApp } from '../../store/AppContext';
import { kubunLabel } from '../../utils/memberUtils';
import { isManager, canManageMembers } from '../../utils/permissions';
import { Icon } from '../ui/Icon';
import { NotificationBell } from './NotificationBell';
import { TopnavBar } from './topbar/TopnavBar';
import { UserSwitchMenu } from './topbar/UserSwitchMenu';
import { TopbarMoreMenu } from './topbar/TopbarMoreMenu';

export default function Topbar({ onToast }) {
  const { S, act } = useApp();

  const currentUser = S.members.find(m => m.id === S.uid);
  const isMgr       = isManager(currentUser);          // 구분 배지 표시용

  return (
    <div className="topbar">
      <TopnavBar isManager={canManageMembers(currentUser)} />

      <div className="tr">
        <span className={`rbadge ${isMgr ? 'bucho' : 'staff'}`}>{kubunLabel(isMgr)}</span>

        <NotificationBell onToast={onToast} />

        <div className="topbar-inline-actions">
          {/* 다크모드 토글 */}
          <button
            className="tnav icon-btn"
            title={S.darkMode ? '라이트 모드로 전환' : '다크 모드로 전환'}
            onClick={() => act('TOGGLE_DARK')}
            aria-label="모드 전환"
          ><Icon name={S.darkMode ? 'sun' : 'moon'} size={16} /></button>

          {/* 휴지통 */}
          <button
            className="tnav icon-btn trash-trigger"
            title={`휴지통 ${(S.deletedTasks ?? []).length}건`}
            onClick={() => act('SET_UI', { patch: { modalTrash: true } })}
            aria-label="휴지통 열기"
          >
            <Icon name="trash" size={16} />
            {(S.deletedTasks ?? []).length > 0 && (
              <span className="trash-trigger-badge">{S.deletedTasks.length}</span>
            )}
          </button>
          {/* 설정은 아바타 메뉴(UserSwitchMenu)로 집약 — 표준 동선 */}
        </div>

        {/* 모바일 — 다크/휴지통/설정 수납 */}
        <TopbarMoreMenu />

        <UserSwitchMenu />
      </div>
    </div>
  );
}
